import React from 'react'
import './Loader.css';
import { useTranslation } from 'react-i18next';

function Loader() {
  const {t} = useTranslation();
  return (
    <div className="loader-container">
        <div className="loader"></div>
        <p className="loaderText">{t('TEXT_LOADER')}</p>
    </div>
  );
}

export default Loader;